export default __webpack_public_path__ + "static/media/FaceAPi.d9d73df6.PNG";